module.exports = __webpack_public_path__ + "static/media/Raleway-Bold.7802d8b2.ttf";